import styled from "@emotion/styled"

const ArticleWrapper = styled.section`
  padding-top: 30px;
  padding-bottom: 30px;
`

export default ArticleWrapper
